import { vrocManager, vrocFactory, VROCComponentFactory } from '../../_VROC/VROCComponentFactory.js';
import { initOrderMarkupControls } from '../../_Common/app.js';

export class Order {
	constructor(options = {}) {
		this.activeComponent = null;
		this.orderId = this._getOrderId();
		this._registerComponent();
		
	}

	/**
	 * Получение ID заказа со страницы
	 */
	_getOrderId() {
		// Вариант 1: Из скрытого поля #orderId
		const orderIdElement = document.querySelector('#orderId');
		if (orderIdElement && orderIdElement.value) {
			return parseInt(orderIdElement.value);
		}

		// Вариант 2: Из URL параметров
		const urlParams = new URLSearchParams(window.location.search);
		const idFromUrl = urlParams.get('id');
		if (idFromUrl) {
			return parseInt(idFromUrl);
		}

		// Вариант 3: Из data-атрибута
		const dataElement = document.querySelector('[data-order-id]');
		if (dataElement) {
			const idFromData = dataElement.getAttribute('data-order-id');
			if (idFromData) return parseInt(idFromData);
		}

		console.warn('[Order] Order ID not found');
		return null;
	}

	_registerComponent() {
		const baseConfig = {
			template: 'mod_crm/order',           // Путь к XSL шаблону
			node: '.page.order',                 // CSS селектор контейнера заказа
			attach: true,                        // Присоединяемся к существующему DOM
			moduleId: 47,                        // ID модуля CRM
			params: {
				action: 'loadOrder',             // Действие для загрузки заказа
				id: this.orderId                 // ID заказа
			},                                   // Начальные параметры
			autoActions: {                       // Автоматические действия
				updateOrder: {
					successMessage: 'Заказ обновлен',
					errorMessage: 'Ошибка обновления заказа'
				},
				savePaytype: {
					successMessage: 'Тип оплаты обновлен',
					errorMessage: 'Ошибка обновления типа оплаты'
				}
			},
			validation: {
				savePaytype: {
					id: { required: true },
					slt_paytypes: { required: true, type: 'number' }
				}
			},                      // Валидация данных (пока пустая)
			onError: (message, error) => {
				console.error('[Order] Error:', message, error);
			},
			events: VROCComponentFactory.createEvents({
				beforeInit: () => {},
				afterInit: () => {},
				beforeAction: (data) => {},
				afterAction: (data) => {},
				error: (data) => console.error('[Order] Ошибка:', data.message)
			}),
			notifications: {
				show: (message, type) => {
					// Здесь можно добавить показ уведомлений через UI
				}
			}
		};

		vrocManager.registerComponent('order', baseConfig);
	}

	async _createComponent() {
		if (this.activeComponent) {
			this.activeComponent = null;
		}

		const component = await vrocManager.createComponent('order');
		this.activeComponent = component;
		

		return component;
	}

	/**
	 * Публичный метод для обновления компонента
	 * Вызывается всегда, когда мы что-то меняем в сервисах
	 */
	async update() {
		try {
			
			// Создаем компонент если его нет
			if (!this.activeComponent) {
				await this._createComponent();
			}

			// Показываем лоадер
			this._showLoader();

			// Обновляем данные заказа
			await this._updateOrderData();

		} catch (error) {
			console.error('[Order] Error in public update:', error);
		} finally {
			// Скрываем лоадер
			this._hideLoader();
		}
	}

	/**
	 * Инициализация компонента
	 */
	async init() {
		try {
			
			// Проверяем, что мы на странице заказа
			const orderContainer = document.querySelector('.page.order');
			if (!orderContainer) {
				return;
			}

			// Создаем компонент в attach режиме
			await this._createComponent();
			
			// Инициализируем обработчики для наценки
			this._initMarginHandlers();

			if ($('.order').attr('data-new-order'))
			{
				guestsManager.show();
			}
			
		} catch (error) {
			console.error('[Order] Error during initialization:', error);
		}
	}

	async savePaytype(form) {
		try {
			const formData = new FormData(form);
			formData.append('action', 'savePaytype');
			formData.append('id', this.orderId);
			const result = await this.activeComponent.performAction('savePaytype', formData);
			await this._updateOrderData();
			
			// Закрываем попап после успешного сохранения
			this._closePaymentPopup();
		} catch (error) {
			console.error('[Order] Error in savePaytype:', error);
			alert('Ошибка при сохранении типа оплаты. Попробуйте еще раз.');
		}
	}

	/**
	 * Инициализация обработчиков для элементов наценки
	 */
	_initMarginHandlers() {
		// Проверяем, что элементы существуют
		const marginInputs = document.querySelectorAll('.order-calc-markup__control-input');
		const ownMarginInput = document.querySelector('.order-calc-markup__control-own input');
		
		if (marginInputs.length === 0 && !ownMarginInput) {
			return;
		}
		
		// Инициализируем контролы наценки из app.js
		initOrderMarkupControls();

		// Создаем обработчик для radio кнопок, если его еще нет
		if (!this._marginChangeHandler) {
			this._marginChangeHandler = (e) => {
				this.setMargin(e.target);
			};
		}

		// Создаем обработчик для поля "Своя наценка", если его еще нет
		if (!this._ownMarginChangeHandler) {
			this._ownMarginChangeHandler = (e) => {
				this.setMargin(e.target);
			};
		}

		// Обработчики для radio кнопок наценки
		marginInputs.forEach((input) => {
			// Удаляем старые обработчики, если они есть
			input.removeEventListener('change', this._marginChangeHandler);
			
			// Добавляем новый обработчик
			input.addEventListener('change', this._marginChangeHandler);
		});

		// Обработчик для поля "Своя наценка"
		if (ownMarginInput) {
			// Удаляем старые обработчики, если они есть
			ownMarginInput.removeEventListener('input', this._ownMarginChangeHandler);
			
			// Добавляем новый обработчик
			ownMarginInput.addEventListener('input', this._ownMarginChangeHandler);
		}
	}

	/**
	 * Установка наценки
	 */
	async setMargin(element) {
		try {
			// Проверяем, что компонент готов
			if (!this.activeComponent || !this.activeComponent.isReady) {
				return;
			}
			
			const formData = new FormData(element.form);
			formData.append('action', 'setMargin');
			formData.append('id', this.orderId);

			const response = await fetch('/ajax.php?mid=47', {
				method: 'POST',
				body: formData
			});

			if (response.ok) {
				await this._updateOrderData();
			}
		} catch (error) {
			console.error('[Order] Error setting margin:', error);
		}
	}

	/**
	 * Обновление данных заказа
	 */
	async _updateOrderData() {
		try {
			if (!this.activeComponent) {
				return;
			}

			// Проверяем ID заказа
			if (!this.orderId) {
				return;
			}

			// Обновляем компонент через VROC
			const params = {
				action: 'loadOrder',
				id: this.orderId
			};

			await this.activeComponent.updateParams(params);

			// После обновления DOM переинициализируем обработчики
			this._initMarginHandlers();

		} catch (error) {
			console.error('[Order] Error updating order data:', error);
			throw error;
		}
	}

	/**
	 * Показать лоадер
	 */
	_showLoader() {
		const loader = document.querySelector('.order__loader');
		if (loader) {
			loader.classList.add('active');
		}
	}

	/**
	 * Скрыть лоадер
	 */
	_hideLoader() {
		const loader = document.querySelector('.order__loader');
		if (loader) {
			loader.classList.remove('active');
		}
	}

	/**
	 * Закрытие попапа выбора типа оплаты
	 */
	_closePaymentPopup() {
		// Используем popupManager для закрытия попапа
		if (typeof window.popupManager !== 'undefined') {
			window.popupManager.close('popup-order-payment');
		} else {
			// Fallback: ищем попап и закрываем его вручную
			const popup = document.querySelector('.popup[data-popup-name="popup-order-payment"]');
			if (popup) {
				popup.classList.remove('active');
				document.body.classList.remove('no-scroll');
			}
		}
		
		// Простое решение: перевешиваем событие на кнопку оплаты
		this._bindPaymentButton();
	}

	/**
	 * Привязка события на кнопку оплаты
	 */
	_bindPaymentButton() {
		// Небольшая задержка, чтобы DOM успел обновиться
		setTimeout(() => {
			const paymentButton = document.querySelector('button.inline-btn.order-payment__method');
			if (paymentButton) {
				// Удаляем старый обработчик, если есть
				paymentButton.removeEventListener('click', this._paymentButtonHandler);
				// Добавляем новый обработчик
				paymentButton.addEventListener('click', this._paymentButtonHandler);
			}
		}, 100);
	}

	/**
	 * Обработчик кнопки оплаты
	 */
	_paymentButtonHandler = (e) => {
		if (typeof window.popupManager !== 'undefined') {
			window.popupManager.open('popup-order-payment');
		}
	}

	/**
	 * Уничтожение компонента
	 */
	destroy() {
		if (this.activeComponent) {
			// Здесь можно добавить логику очистки
			this.activeComponent = null;
		}
	}
}

// Глобальная регистрация для внешнего доступа
if (typeof window !== 'undefined') {
	window.Order = Order;
}
